import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Fab, Icon } from '@material-ui/core';
import { uploadFileTypeUnsupported, uploadFileSizeLimit, uploadImageResolutionLimit } from 'redux/actions/general';
import { addNewBannerSlideApi } from 'api';
import {fileToBase64} from '../../utils';


const MAX_BANNER_FILE_SIZE = 250 * 1024;

const UploadBannerSlide = ({isOpen}) => {
  const dispatch = useDispatch();
  const [dargClass, setDragClass] = useState('');

  const {
    homepageBannerGroup
  } = useSelector((state) => state.banner_manager);

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragClass('drag-shadow');
  };

  const handleDragStart = () => setDragClass('drag-shadow');

  const handleSaveSlide = (image) => {
    const slideData = {
      image,
      is_active: false,
      title: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      hosted_image: 0,
      url: '',
      alt_text: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      slide_startdate: null,
      slide_enddate: null,
      slide_sort_order: (homepageBannerGroup.slides.length + 1),
      url_target: '_self',
      group_id: [
        `${homepageBannerGroup.group_id}`
      ]
    };

    addNewBannerSlideApi({dispatch, slideData});

    isOpen(false);
  };

  const handleUpLoadBanner = (event) => {
    const {files} = event.target;
    const fileName = event.target.value;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|gif|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');
    const imageSizeValues = {
      height: 0,
      width: 0
    };
    const reader = new FileReader();

    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
      const image = new Image();

      image.src = e.target.result;
      image.onload = async () => {
        const {height, width} = image;

        imageSizeValues.height = height;
        imageSizeValues.width = width;

        if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
          dispatch(uploadFileTypeUnsupported());
        } else if (files[0].size > MAX_BANNER_FILE_SIZE) {
          dispatch(uploadFileSizeLimit('250kB'));
        } else if (imageSizeValues.width === 1660 && imageSizeValues.height === 500) {
          const file = await fileToBase64(files[0]);
          handleSaveSlide(btoa(file));
        } else {
          dispatch(uploadImageResolutionLimit('1660 x 500px'));
        }
      };
    };
  };

  const handleUploadBannerOnDrag = (event) => {
    event.preventDefault();
    event.persist();

    const {files} = event.dataTransfer;
    const fileName = files[0].name;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|gif|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');
    const imageSizeValues = {
      height: 0,
      width: 0
    };
    const reader = new FileReader();

    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
      const image = new Image();

      image.src = e.target.result;
      image.onload = async () => {
        const {height, width} = image;

        imageSizeValues.height = height;
        imageSizeValues.width = width;

        if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
          dispatch(uploadFileTypeUnsupported());
        } else if (files[0].size > MAX_BANNER_FILE_SIZE) {
          dispatch(uploadFileSizeLimit('250kB'));
        } else if (imageSizeValues.width !== 1660 || imageSizeValues.height !== 500) {
          dispatch(uploadImageResolutionLimit('1660 x 500px'));
        } else {
          const file = await fileToBase64(files[0]);
          handleSaveSlide(btoa(file));
        }

        setDragClass('');
        return false;
      };
    };
  };

  return (
    <>
      <div
        className={`h-300 w-full mb-6 flex-column justify-center items-center dropzone ${dargClass}`}
        onDragEnter={handleDragStart}
        onDragOver={handleDragOver}
        onDrop={handleUploadBannerOnDrag}
      >
        <div>
          <Icon className="pr-8 text-48" fontSize="large" color="primary">cloud_upload</Icon>
        </div>

        <span className="font-bold text-16 text-brand">Drag and drop your file here</span>
        <span className="text-13 text-muted">Files supported:  JPG, JPEG, GIF, PNG</span>
        <span className="text-13 text-muted">File size should be less than 250kB.</span>
        <span className="text-13 text-muted">Image resolution should be exactly 1660x500px (aspect ratio 3.32:1).</span>
        <p className="text-13 text-brand my-2">or</p>
        <label htmlFor="upload-slide-image">
          <Fab
            component="span"
            variant="extended"
            className="border-radius-30 capitalize bg-white text-13 h-30px text-primary font-bold border-1-primary box-shadow-none"
          >
            Browse file
          </Fab>
        </label>
        <input
          className="hidden"
          onChange={handleUpLoadBanner}
          id="upload-slide-image"
          type="file"
          accept="image/png, image/jpeg, image/jpg, image/gif"
        />
      </div>

    </>
  );
};

export default UploadBannerSlide;
